import { useEffect, useState } from "react";


export default function Increment ({ inicio = 1, incremento = 2, limite = 10, intervalo = 300 }) {
  const [numero, setNumero] = useState(inicio);

  useEffect(() => {
    const interval = setInterval(() => {
      setNumero(prev => {
        const siguiente = prev + incremento;
        if (siguiente >= limite) {
          clearInterval(interval);
          return limite; 
        }
        return siguiente;
      });
    }, intervalo);

    return () => clearInterval(interval);
  }, [incremento, limite]);

  return numero;
}